var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.809 21.646l-6.205-6.205a9.68 9.68 0 001.857-5.711C19.461 4.365 15.096 0 9.73 0 4.365 0 0 4.365 0 9.73c0 5.366 4.365 9.73 9.73 9.73a9.678 9.678 0 005.487-1.698L21.455 24l2.354-2.354zM2.854 9.73c0-3.792 3.085-6.877 6.877-6.877s6.877 3.085 6.877 6.877-3.085 6.877-6.877 6.877A6.884 6.884 0 012.854 9.73z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZmlsbD0iY3VycmVudENvbG9yIiBkPSJNMjMuODA5IDIxLjY0NmwtNi4yMDUtNi4yMDVhOS42OCA5LjY4IDAgMDAxLjg1Ny01LjcxMUMxOS40NjEgNC4zNjUgMTUuMDk2IDAgOS43MyAwIDQuMzY1IDAgMCA0LjM2NSAwIDkuNzNjMCA1LjM2NiA0LjM2NSA5LjczIDkuNzMgOS43M2E5LjY3OCA5LjY3OCAwIDAwNS40ODctMS42OThMMjEuNDU1IDI0bDIuMzU0LTIuMzU0ek0yLjg1NCA5LjczYzAtMy43OTIgMy4wODUtNi44NzcgNi44NzctNi44NzdzNi44NzcgMy4wODUgNi44NzcgNi44NzctMy4wODUgNi44NzctNi44NzcgNi44NzdBNi44ODQgNi44ODQgMCAwMTIuODU0IDkuNzN6Ii8+PC9zdmc+Cg==";
export { SvgSearch as ReactComponent };